import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export default function UsdmSwitch(props) {
	const { showdm, setShowdm, sx={} } = props;

	const handleSwitchChange = (event) => {
		setShowdm(event.target.checked);
	};

	return (
		<>
			<FormControlLabel
				sx={sx}
				control={
					<Switch
						checked={showdm}
						onChange={handleSwitchChange}
						size="small"
					/>
				}
				label="Show USDM Map"
			/> 
		</>
	);
}
